import './css/LayerView.css';
import { connect } from "react-redux";
import { useEffect } from 'react';
import * as d3 from 'd3';
import store from "./store";
import { directSelect, select } from "./canvasSlice";
import { activateTool } from './toolSlice';


const mapStateToProps = state => ({
    selected: state.canvas.selected,
    dataItemJoined: state.canvas.dataItemJoined,
    newItemCreated: state.canvas.newItemCreated,
    itemsDeleted: state.canvas.itemsDeleted,
    itemUpdated: state.canvas.itemUpdated
});

const left = 20, offset = 25, lineHt = 25, top = 20;

const enumerateLayers = (item, list, level) => {
    list.push({item: item, level: level});
    if (item.children) {
        switch (item.type) {
            case "collection":
                enumerateLayers(item.firstChild, list, level+1);
                break;
            case "axis":
            case "legend":
            case "gridlines":
                break;
            default:
                for (let i = item.children.length - 1; i >= 0; i--) {
                    enumerateLayers(item.children[i], list, level+1);
                }
                break;
        }
    }
};

const getLayerLabel = (item) => {
    if (item.type === "axis") {
        return item.channel.substring(0, 1).toUpperCase() + item.channel.substring(1) + " axis: " + item.field;  
    }
    let l = item.type.substring(0, 1).toUpperCase() + item.type.substring(1);
    if (item.dataScope) {
        let peers = item.getScene().getPeers(item);
        if (peers.length > 1)
            l += " (" + peers.length + ")";
        let fields = item.dataScope.fields;
        if (item.parent && item.parent.type === "collection" && item.parent.dataScope) {
            fields = fields.filter(d => item.parent.dataScope.fields.indexOf(d) < 0);
        }
        let d = fields.join(", ");
        if (d === "atlas_rowId")
            d = "row ID";
        if (d !== "")
            l += ": " + d;
    }
    return l;
};

const getLayerId = (item) => {
    switch (item.type) {
        case "axis":
        case "legend":
            return item.id;
        default:
            if (item.classId)
                return item.classId;
            else
                return item.id;
    }
}

function LayerView(props) {

    useEffect(() => {
        const layers = [];
        enumerateLayers(props.scene, layers, -1);
        layers.forEach((d, i) => d.index = i);
        const lv = d3.select(".layerView");
        lv.selectAll('*').remove();
        lv.append("text").text("Layers").style("font-weight", "bold").attr("class", "layerText")
            .attr("x", 20).attr("y", 16);
        let g = lv.selectAll(".layer").data(layers.slice(1)).enter().append("g").attr("class", "layer");
        
        g.append("rect").attr("class", "layerRow").attr("id", d => getLayerId(d.item))
            .attr("x", 0).attr("y", d => top + lineHt * d.index - 3)
            .attr("width", 260).attr("height", lineHt)
            .on("click", (e, d) => {
                store.dispatch(directSelect(null));
                store.dispatch(activateTool("Select"));
                store.dispatch(select([d.item.id]));
            });
        g.append("image").attr("class", "layerIcon")
            .attr("x", d => left + offset * d.level).attr("y", d => top + lineHt * d.index + 2)
            .attr("href", d => "/app/icons/"+d.item.type + ".png");
        g.append("text").attr("class", "layerText")
            .attr("x", d => left + offset * d.level + 22).attr("y", d => top + lineHt * d.index + 1)
            .text(d => getLayerLabel(d.item));
    }, [props.scene, props.dataItemJoined, props.newItemCreated, props.itemsDeleted, props.itemUpdated]);

    useEffect(() => {
        d3.selectAll(".layerRow").classed("layerSelected", false);
        if (props.selected.length > 0) {
            for (let s of props.selected) {
                let itm = props.scene.getItem(s);
                if (!itm) return;
                d3.select(".layerView").select("#"+getLayerId(itm)).classed("layerSelected", true);
            }
        }
    }, [props.scene, props.selected]);

    return (
        <svg className="layerView">
        </svg>
    );
}

export default connect(mapStateToProps)(LayerView);